export * from './recovery-pass.component';
